module.exports = __webpack_public_path__ + "img/bg6.674b7320.png";